import { Box, CircularProgress } from "@mui/material";
import { useEntityResponsible } from "../../../hooks/Entity";
import EntityResponsibles from "../../Entities/Responsibles/EntityResponsibles";

interface ResponsiblesTabProps {
  entityId?: string;
  entityName?: string;
  handleError?: (err: any) => void;
}

const ResponsiblesTab: React.FC<ResponsiblesTabProps> = ({ entityId, entityName, handleError }) => {
  const { responsiblesData, isPending, createResponsible, updateResponsible, deleteResponsible, setPrimaryResponsible } = useEntityResponsible(entityId);

  if (isPending && responsiblesData.length === 0)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <EntityResponsibles
      entityId={Number(entityId)}
      entityName={entityName ?? ""}
      responsiblesData={responsiblesData}
      onCreate={async (values) => {
        await createResponsible(values).catch(handleError)
      }}
      onUpdate={async (id, values) => {
        await updateResponsible({ ResponsibleId: id, values }).catch(handleError)
      }}
      onDelete={async (id) => {
        await deleteResponsible(id).catch(handleError)
      }}
      onSetPrimary={async (id) => {
        await setPrimaryResponsible(id).catch(handleError)
      }}
    />
  );
};

export default ResponsiblesTab;